import React from "react";
import { Container } from "react-bootstrap";
import styled from "styled-components";

const votingSquareCommon = `
  border: 2px solid black;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 26px;
  font-weight: bold;
  color: black;
`;

const VotingSquare1 = styled.div`
  ${votingSquareCommon}
  margin-left: 8px;
  margin-right: 8px;
`;

const VotingSquare2 = styled.div`
  ${votingSquareCommon}
  margin-left: 8px;
  margin-right: 0px;
`;

const Line1 = styled.div`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 26px;
  color: black;
`;

const Line2 = styled.div`
  margin-top: 12px;
  display: flex;
  text-align: center;
  justify-content: center;
  font-weight: bold;
  font-size: 18px;
  color: black;
`;

const Line3 = styled.div`
  display: flex;
  justify-content: center;
  font-style: italic;
  margin-bottom: 24px;
  color: black;
`;


type PreferenceTas25SpecialClark12Props = {};

export function PreferenceTas25SpecialClark12({
})  {
  return (
    <Container>
      <Line1>
        VOTE <VotingSquare1>1</VotingSquare1>AND<VotingSquare2>2</VotingSquare2>
      </Line1>

      <Line2>
        Vica BAYLEY and Helen BURNET
      </Line2>

      <Line3>
        in the order of your choice
      </Line3>
    </Container>
  );
};